import type { ShopClass, ShopFilters } from "./types";

export const SHOP_CLASSES: ShopClass[] = ["A", "B", "C"];

export const IRAQ_GOVERNORATES = [
  "الانبار",
  "بابل",
  "بغداد",
  "البصرة",
  "ذي قار",
  "ديالى",
  "دهوك",
  "اربيل",
  "حلبجة",
  "كربلاء",
  "كركوك",
  "ميسان",
  "المثنى",
  "النجف",
  "نينوى",
  "القادسية",
  "صلاح الدين",
  "السليمانية",
  "واسط"
];

export const BAGHDAD_CITIES = ["الكرخ", "الرصافة"];

export const DEFAULT_MAP_CENTER = {
  latitude: 33.3152,
  longitude: 44.3661
};

export const EMPTY_FILTERS: ShopFilters = {
  search: "",
  shopClass: "all",
  shopGovenorate: "",
  shopCity: "",
  shopDistrict: "",
  locationStatus: "all",
  sortBy: "newest"
};
